import ResidentHeader from 'components/ResidentHeader';
import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import Aside from './components/Aside';
import HeaderMobile from './components/HeadMobile';
import LayoutContext from './context';
import { useHistory, useLocation } from 'react-router-dom';
import routePaths from 'constants/route-paths';
import BaseDataHeader from 'components/BaseDataHeader';
import RouteLeavingGuard from 'components/RouteLeavingGuard';

const Container = styled.div`
  padding: 20px;
  padding-right: 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  @media screen and (max-width: 991.98px) {
    height: calc(100vh - 55px); // 55px is height of header on mobile size
  }
`;

type Prop = {
  children: ReactNode;
};

const ContentWrapper = styled.div`
  flex: 1 1 0;
  height: 100%;
  overflow-y: auto;
  padding-right: 20px;
  position: relative;
`;

const Header = styled.div`
  padding-right: 20px;
`;

const Layout = ({ children }: Prop) => {
  const history = useHistory();
  const pathname = useLocation().pathname;
  const [isInEditMode, setIsInEditMode] = useState<boolean>(false);

  return (
    <LayoutContext setEditMode={setIsInEditMode}>
      <div className="header-mobile-fixed subheader-enabled aside-enabled aside-fixed aside-secondary-enabled">
        <HeaderMobile />
        <div className="content d-flex flex-column flex-root">
          <div className="d-flex flex-row flex-column-fluid page">
            <Aside />
            <div id="kt_content" className={`d-flex flex-column flex-row-fluid wrapper`}>
              <Container>
                <Header>
                  {pathname.includes(routePaths.DASHBOARD) && <ResidentHeader />}
                  {pathname.includes(routePaths.BASE_DATA) && <BaseDataHeader />}
                </Header>
                <ContentWrapper id="contentWrapper" data-test="content-wrapper">
                  <RouteLeavingGuard
                    when={isInEditMode}
                    navigate={(path) => history.push(path)}
                    shouldBlockNavigation={() => {
                      if (isInEditMode) {
                        return true;
                      }
                      return false;
                    }}
                  />
                  {children}
                </ContentWrapper>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </LayoutContext>
  );
};

export default Layout;
